import { useTheme, Box, Typography, Button } from "@mui/material";
import {
  WelcomeAndIntructionsPopUpRoot,
  WelcomeAndIntructionsPopUpItem,
} from "./WelcomeAndIntructionsPopUp.styles";
import RotateDesktopImg from "../../assets/instructions/camera_rotation_desktop.svg";
import ZoomDesktopImg from "../../assets/instructions/camera_zoom_desktop.svg";
import CameraPanDesktopImg from "../../assets/instructions/camera_pan_desktop.svg";
import RotateMobileImg from "../../assets/instructions/rotate-mobile_img.svg";
import ZoomMobileImg from "../../assets/instructions/zoom-mobile_img.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useDevice } from "../../hooks/useDevice";
import wydstLogo from "../../assets/WYDST_R8S_logo.svg";

export const WelcomeAndIntructionsPopUp = ({ onHandleClose }) => {
  const theme = useTheme();
  const { isTouch } = useDevice();

  const iconsDesktop = [
    {
      alt: "Rotate",
      imgSrc: RotateDesktopImg,
      title: "Camera 360 rotation",
      descriptionMouse: "Left click (Mouse)",
      descriptionTrackpad: "Swipe (Trackpad)",
    },
    {
      alt: "Zoom",
      imgSrc: ZoomDesktopImg,
      title: "Camera zoom",
      descriptionMouse: "Wheel scroll (Mouse)",
      descriptionTrackpad: "Pinch (Trackpad)",
    },
    {
      alt: "Camera Pan",
      imgSrc: CameraPanDesktopImg,
      title: "Camera pan",
      descriptionMouse: "Middle button click + move (Mouse)",
      descriptionTrackpad: "",
    },
  ];

  const iconsMobile = [
    {
      alt: "Rotate",
      imgSrc: RotateMobileImg,
      title: "Camera 360 rotation",
      descriptionMouse: "",
      descriptionTrackpad: "Swipe to rotate",
    },
    {
      alt: "Zoom",
      imgSrc: ZoomMobileImg,
      title: "Camera zoom",
      descriptionMouse: "",
      descriptionTrackpad: "Pinch to zoom",
    },
  ];

  const instructions = isTouch ? iconsMobile : iconsDesktop;

  return (
    <WelcomeAndIntructionsPopUpRoot>
      <Button
        variant="text"
        sx={{
          position: { xs: "fixed", lg: "absolute" },
          zIndex: 9,
          top: 0,
          right: { xs: -10, lg: 0 },
          color: theme?.palette?.companyColors?.secondary,
          fontSize: { xs: "1.75rem", md: "2.25rem" },
          transition: "all 0.3s ease",
        }}
        onClick={() => {
          onHandleClose(false, "click");
        }}
      >
        <CloseIcon
          sx={{
            padding: "3px 0 0",
            fontSize: "3.5rem",
          }}
        />
      </Button>
      <Box>
        <Box
          component="img"
          src={wydstLogo}
          alt="Fallback"
          sx={{
            height: { xs: "50px", md: "80px" },
            display: "block",
            zIndex: 1,
          }}
        />
        <Typography
          className="instructions__title"
          variant="h4"
          sx={{
            fontSize: "3rem",
            fontWeight: 600,
            mb: { xs: "1.5rem", md: "0" },
          }}
        >
          Configurator
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "stretch",
          "@media (orientation: landscape)": {
            flexDirection: "row",
          },
          [theme.breakpoints.up("md")]: {
            flexDirection: "row",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            flex: 1,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: { xs: "0", md: "5rem" },
            "&:after": {
              content: "''",
              display: "block",
              position: "absolute",
              width: "100%",
              height: "1px",
              top: "auto",
              right: 0,
              left: 0,
              bottom: 0,
              background: theme?.palette?.companyColors?.greyLight1,
              margin: "auto",
              [theme.breakpoints.between("md", "lg")]: {
                "@media (orientation: portrait)": {
                  width: "1px",
                  height: "90%",
                  top: "5%",
                  right: 0,
                  left: "auto",
                  bottom: "auto",
                },
              },
              [theme.breakpoints.down("lg")]: {
                "@media (orientation: landscape)": {
                  width: "1px",
                  height: "90%",
                  top: "5%",
                  right: 0,
                  left: "auto",
                  bottom: "auto",
                },
              },
              [theme.breakpoints.up("lg")]: {
                width: "1px",
                height: "90%",
                top: "5%",
                right: 0,
                left: "auto",
                bottom: "auto",
              },
            },
          }}
        >
          <Typography
            className="instructions__title"
            variant="body1"
            sx={{
              textAlign: "left",
              position: "relative",
              fontSize: { xs: "1.6rem", md: "1.75rem" },
              mb: "3.5rem",
              [theme.breakpoints.down("lg")]: {
                "@media (orientation: landscape)": {
                  mb: 0,
                  pr: 2,
                },
              },
              [theme.breakpoints.up("md")]: { mb: "0" },
            }}
          >
            The <b>WYDST R8S</b> isn’t for blending in, it’s for standing out.
            <br />
            <br />
            Widebody comes standard, track focus comes built in. The rest is
            yours to define: colors, wheels, materials, and more. Build it your
            way and create a spec no one else has.
            <br />
            <br />
            <b>Save your build code</b> or <b>press “I’m Interested”</b> to let
            us know.
            <br />
            <br />
            With enough demand, this package will become reality for the R8 V10
            mk2.
          </Typography>
        </Box>

        <Box
          sx={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            gap: { xs: "2.5rem", md: "4.5rem" },
          }}
        >
          {instructions.map((item, index) => (
            <WelcomeAndIntructionsPopUpItem key={index}>
              <Box
                component="img"
                src={item.imgSrc}
                alt={item.alt}
                sx={{
                  width: {
                    xs: "7rem",
                    sm: "5rem",
                    md: "7rem",
                    lg: "7rem",
                    xl: "4rem",
                  },
                }}
              />
              <Box
                sx={{
                  textAlign: "center",
                  fontWeight: 300,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "1.6rem",
                    fontWeight: 700,
                    lineHeight: 1.1,
                    marginBottom: "0.25rem",
                    textAlign: "center",
                  }}
                >
                  {item.title}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap:
                      item.descriptionMouse &&
                      item.descriptionTrackpad &&
                      "1rem",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box component="span" sx={{ fontSize: "1.25rem" }}>
                    {item.descriptionMouse}
                  </Box>
                  {item.descriptionMouse && item.descriptionTrackpad && (
                    <Box component="span" sx={{ fontSize: "1.25rem" }}>
                      |
                    </Box>
                  )}
                  <Box component="span" sx={{ fontSize: "1.25rem" }}>
                    {item.descriptionTrackpad}
                  </Box>
                </Box>
              </Box>
            </WelcomeAndIntructionsPopUpItem>
          ))}
        </Box>
      </Box>
      <Typography
        className="instructions__title"
        variant="body1"
        sx={{
          alignSelf: "center",
          margin: "40px auto 0",
          fontSize: "1.2rem",
          textAlign: "center",
        }}
      >
        <b>*Disclaimer:</b> Prices shown in this configurator are illustrative
        only and meant to indicate potential costs based on selected options.
      </Typography>
    </WelcomeAndIntructionsPopUpRoot>
  );
};
